<script>
export default {
    props: {
        method: Object,
        total: Number,
        subtotal: Number
    },
    computed: {
        disabled() {
            return (this.method.is_balance === '1' || this.method.is_balance === 1) && this.method.user_balance < this.subtotal;
        }
    },
    methods: {
        select() {
            if(!this.disabled) {
                this.$emit('onSelected', this.method.slug);
            }
        }
    },
    emits: ['onSelected']
}
</script>
<template>
    <div class="component-payment" @click="select"
         :class="{selected: method.selected, saving: method.saving, disabled: disabled}">
        <div class="payment-loader" v-if="method.saving">
            <div class="vue-loader-dark"></div>
        </div>
        <div class="payment-info">
            <img v-bind:src="'/build/frontend/img/payments/' + method.slug  +'.svg'">
            <div class="mt-3"><small>{{ method.name }}</small></div>
            <div v-if="disabled" class="small" v-html="$translate('checkout.payment_prepaid_balance_disabled', {url: '/manager/orders/balance-payment'})"></div>
        </div>
    </div>
</template>
